/** The card's token when this page is the guest's page at a table (/tafel/<token>), else null. */
export function tableOrderToken(pathname: string): string | null {
  return /^\/tafel\/([A-Za-z0-9]{12})\/?$/.exec(pathname)?.[1] ?? null;
}
